module.exports = __webpack_public_path__ + "img/80400.de95c7b8.jpg";